import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import entryActions from '../entry-actions';
import InviteUserModal from '../components/InviteUserModal';

const mapStateToProps = () => ({
  // No necesitamos estado específico para este modal
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClose: entryActions.closeModal,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(InviteUserModal);
